import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled'

const ButtonWrapper = styled.button`
    width: 92px;
    height: 36px;
    
    display: flex;
    justify-content: center;
    align-items: center;
    
    background: var(--accent);
    /* shadow-md */
    box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1), 0px 2px 4px rgba(0, 0, 0, 0.06);
    border-radius: 4px;
    border: 1px solid #CBD5E0;
    
     
    background-position: center;
    transition: background 0.8s;
    
    :hover {
      background: rgba(118,118,117,0.28) radial-gradient(circle, transparent 1%, rgba(118,118,117,0.17) 1%) center/15000%;
    }
    
    :active {
      background-color: #767675;
      background-size: 100%;
      transition: background 0s;
    }
    
    :focus {
        outline: none
    }
    
    
    font-family: Metropolis;
    font-style: normal;
    font-weight: 500;
    font-size: 12px;
    line-height: 12px;
    /* identical to box height */
    text-align: center;

    color: #FFFFFF;
    user-select: none;
    cursor: pointer;
    
    background: ${props => props.disabled ? 'rgba(118,118,117,0.28)' : 'var(--accent)'};
`;

function ActionButton(props) {
    return (
        <ButtonWrapper
            onClick={props.onClick}
            disabled={props.disabled}
        >
            {props.children}
        </ButtonWrapper>
    );
}

ActionButton.propTypes = {};
ActionButton.defaultProps = {};

export default ActionButton;
